module.exports = __webpack_public_path__ + "img/icon_number_8@2x.5ca805f6.png";